function partition<T>(array: T[], filter: (e: T) => boolean) {
  const pass: T[] = [],
    fail: T[] = []
  array.forEach((e) => (filter(e) ? pass : fail).push(e))
  return [pass, fail]
}

export default partition
